module.exports = require("react-clipboard.js");